import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getBiDataForTierLink } from '../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import TierPromotionCard from '../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../TierPromotionCardWithFellaTooltip';
import type { FeedCardProps } from '../types';
import s from './Tier.scss';

const TierFeedCardContents: React.FC<FeedCardProps> = ({
  deviation,
  width,
  className,
  showTierPromotionTooltip,
}) => {
  const biData = getBiDataForTierLink(deviation);

  return (
    <div className={classnames(s['root'], className)}>
      {showTierPromotionTooltip ? (
        <TierPromotionCardWithFellaTooltip deviation={deviation} width={width} isPostsFeedCard />
      ) : (
        <TierPromotionCard deviation={deviation} width={width} />
      )}
      <BiLink
        className={s['link-overlay']}
        biData={biData}
        href={Url.userSubscriptionsPath({
          username: deviation.author!.username,
          tierDeviationId: deviation.deviationId,
          tierContentType: 'deviations',
        })}
      >
        <span />
      </BiLink>
    </div>
  );
};
TierFeedCardContents.displayName = 'TierFeedCardContents';

export default TierFeedCardContents;
